<template>
  <div class="w" style="position: relative" :class="{ fullscreen: isRouteFullscreen }">
    <div style="height: 30px; position: absolute; z-index: 1; left: 0; right: 0; transform: translateY(20px);" v-if="isRouteFullscreen">
      <div class="svgs" style="float: right;">
        <svg @click="$router.push('/fullscreen/monitor')" style="margin-right: -20px;" t="1751610347433" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1749" width="60" height="30"><path d="M598.361605 38.378364v198.288215H962.956065c38.378364 0 63.96394 25.585576 63.96394 63.963941v422.162006c0 38.378364-25.585576 63.96394-63.96394 63.96394H598.361605v198.288215c0 6.396394-6.396394 19.189182-12.792788 25.585576-12.792788 12.792788-38.378364 19.189182-51.171152 6.396394l-511.711523-454.143976-6.396394-6.396394c-25.585576-25.585576-19.189182-63.96394 6.396394-89.549517l511.711523-454.143976c12.792788-6.396394 19.189182-12.792788 25.585576-12.792788 25.585576 0 38.378364 19.189182 38.378364 38.378364z" p-id="1750"></path></svg>
        <svg @click="$router.push('/fullscreen/list')" t="1751608233199" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1468" width="60" height="30"><path d="M466.052637 0c6.384283 0 12.768565 6.384283 25.53713 12.768565l510.742616 453.284072c25.537131 25.537131 31.921413 63.842827 6.384283 89.379957l-6.384283 6.384283-510.742616 453.284071c-12.768565 12.768565-38.305696 12.768565-51.074261-6.384282-6.384283-6.384283-12.768565-19.152848-12.768565-25.537131v-197.912764H63.842827c-38.305696 0-63.842827-25.537131-63.842827-63.842827V300.061287c0-38.305696 25.537131-63.842827 63.842827-63.842827h363.904114V38.305696c0-19.152848 12.768565-38.305696 38.305696-38.305696z" p-id="1469"></path></svg>
      </div>
    </div>
    <div class="container" ref="container">
      <div id="map" ref="mapChart" />
      <div class="header">
        <div class="header-inner">
          <template v-if="lang === 'en'">
            <dv-decoration-10 style="width: 30%; height: 5px"/>
            <dv-decoration-8 :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem;"/>
            <div style="width: 21%" class="title_wrapper">
              <h1 class="title" style="text-wrap: nowrap;">Deman Service Monitor</h1>
              <dv-decoration-6 style="width: 100%; height: 7px; margin-top: .2083rem;"/>
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem"/>
            <dv-decoration-10 style="width: 27.5%; height: 5px; transform: rotate(180deg)"/>
          </template>
          <template v-else>
            <dv-decoration-10 style="width: 30%; height: 5px"/>
            <dv-decoration-8 :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem;"/>
            <div style="width: 16%" class="title_wrapper">
              <h1 class="title" style="text-wrap: nowrap">德曼服务监测中心</h1>
              <dv-decoration-6 style="width: 100%; height: 7px; margin-top: .2083rem;"/>
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem;"/>
            <dv-decoration-10 style="width: 30%; height: 5px; transform: rotate(180deg)"/>
          </template> 
        </div>
      </div>
      <div class="toggleNav">
        <div class="item" v-for="(v, k) in dataTypeList" :key="k">
          <div v-html="$t(`overview.serviceContent.${v.name}`)"></div>
          <div style="color: #03a9f4">{{ v.value }}</div>
        </div>
      </div>
      <div class="col" style="left: .1%;">
        <dv-border-box-12 style="height: 27.5%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: -1px; left: 3px; scale: .8">
              <svg class="svg-inline--fa fa-chart-column icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-column" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" fill="currentColor" d="M32 32C49.67 32 64 46.33 64 64V400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32zM160 224C177.7 224 192 238.3 192 256V320C192 337.7 177.7 352 160 352C142.3 352 128 337.7 128 320V256C128 238.3 142.3 224 160 224zM288 320C288 337.7 273.7 352 256 352C238.3 352 224 337.7 224 320V160C224 142.3 238.3 128 256 128C273.7 128 288 142.3 288 160V320zM352 192C369.7 192 384 206.3 384 224V320C384 337.7 369.7 352 352 352C334.3 352 320 337.7 320 320V224C320 206.3 334.3 192 352 192zM480 320C480 337.7 465.7 352 448 352C430.3 352 416 337.7 416 320V96C416 78.33 430.3 64 448 64C465.7 64 480 78.33 480 96V320z"></path></svg>
              <span class="title" style="font-size: .1875rem">{{ $t('overview.serviceContent.statistics') }}</span>
            </div>
            <div class="barchart" style="width: 100%; height: 100%;"/>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 45%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: -1px; left: 3px; scale: .8">
              <svg class="svg-inline--fa fa-chart-column icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-column" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" fill="currentColor" d="M32 32C49.67 32 64 46.33 64 64V400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32zM160 224C177.7 224 192 238.3 192 256V320C192 337.7 177.7 352 160 352C142.3 352 128 337.7 128 320V256C128 238.3 142.3 224 160 224zM288 320C288 337.7 273.7 352 256 352C238.3 352 224 337.7 224 320V160C224 142.3 238.3 128 256 128C273.7 128 288 142.3 288 160V320zM352 192C369.7 192 384 206.3 384 224V320C384 337.7 369.7 352 352 352C334.3 352 320 337.7 320 320V224C320 206.3 334.3 192 352 192zM480 320C480 337.7 465.7 352 448 352C430.3 352 416 337.7 416 320V96C416 78.33 430.3 64 448 64C465.7 64 480 78.33 480 96V320z"></path></svg>
              <span class="title" style="font-size: .1875rem">{{ $t('overview.serviceContent.volume') }}</span>
            </div>
            <div style="width: 100%; height: 100%; padding-top: 30px;" class="capsule_wrapper">
              <dv-scroll-ranking-board v-if="isBoardShow" :config="config" style="width: 100%; height: 100%; padding: 0 1%" />
            </div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 27.5%">
          <div class="chart-inner-bg" style="padding-top: 30px">
            <div style="position: absolute; top: -1px; left: 3px; scale: .8">
              <svg class="svg-inline--fa fa-chart-area icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-area" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" fill="currentColor" d="M64 400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32C49.67 32 64 46.33 64 64V400zM128 320V236C128 228.3 130.8 220.8 135.9 214.1L215.3 124.2C228.3 109.4 251.4 109.7 263.1 124.8L303.2 171.8C312.2 182.7 328.6 183.4 338.6 173.4L359.6 152.4C372.7 139.3 394.4 140.1 406.5 154.2L472.3 231C477.3 236.8 480 244.2 480 251.8V320C480 337.7 465.7 352 448 352H159.1C142.3 352 127.1 337.7 127.1 320L128 320z"></path></svg>
              <span class="title" style="font-size: .1875rem">{{ $t('overview.serviceContent.fault') }}</span>
            </div>
            <div class="linechart" style="width: 100%; height: 100%"></div>
          </div>
        </dv-border-box-12>
      </div>
      <div class="col" style="right: .1%;">
        <dv-border-box-12 style="height: 30%">
          <div class="chart-inner-bg flex">
            <div style="position: absolute; top: -1px; left: 3px; scale: .8">
              <svg class="svg-inline--fa fa-chart-pie icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-pie" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path class="" fill="currentColor" d="M304 16.58C304 7.555 310.1 0 320 0C443.7 0 544 100.3 544 224C544 233 536.4 240 527.4 240H304V16.58zM32 272C32 150.7 122.1 50.34 238.1 34.25C248.2 32.99 256 40.36 256 49.61V288L412.5 444.5C419.2 451.2 418.7 462.2 411 467.7C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zM558.4 288C567.6 288 575 295.8 573.8 305C566.1 360.9 539.1 410.6 499.9 447.3C493.9 452.1 484.5 452.5 478.7 446.7L320 288H558.4z"></path></svg>
              <span class="title" style="font-size: .1875rem">{{ $t('overview.serviceContent.maintain') }}</span>
            </div>
            <div class="piechart" style="width: 100%; height: 100%"></div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 70%">
          <div class="chart-inner-bg flex">
            <div style="position: absolute; top: -1px; left: 3px; scale: .8">
              <svg class="svg-inline--fa fa-chart-pie icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-pie" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path class="" fill="currentColor" d="M304 16.58C304 7.555 310.1 0 320 0C443.7 0 544 100.3 544 224C544 233 536.4 240 527.4 240H304V16.58zM32 272C32 150.7 122.1 50.34 238.1 34.25C248.2 32.99 256 40.36 256 49.61V288L412.5 444.5C419.2 451.2 418.7 462.2 411 467.7C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zM558.4 288C567.6 288 575 295.8 573.8 305C566.1 360.9 539.1 410.6 499.9 447.3C493.9 452.1 484.5 452.5 478.7 446.7L320 288H558.4z"></path></svg>
              <span class="title" style="font-size: .1875rem">{{ $t('overview.serviceContent.dispatch') }}</span>
            </div>
            <div style="width: 100%; height: 100%; padding-top: 30px;" class="capsule_wrapper">
              <vue-seamless-scroll :data="totalList.dispatchList" class="warp">
                <ul class="item">
                  <li v-for="(item, index) in totalList.dispatchList" :key="index">
                    <div class="dot-wrap">
                      <div :class="item.finished ? 'success-bgc' : 'primary-bgc'" class="dot"></div>
                    </div>
                    <div style="width: 100%;font-size: 15px;">
                      <div style="display: flex;flex-direction: row;justify-content: space-between;color: hsla(0,0%,100%,.59);margin-bottom: 2px;">
                        <div :title="item.company" v-text="item.company" style="width: 59%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"></div>
                        <div v-text="item.createdAt" style="width: 37%"></div>
                      </div>
                      <div :class="item.finished ? 'success-color' : 'primary-color'">
                        <span>单号：{{ item.billNo }}, 施工人{{ item.staff }}{{ item.finished ? '已完成' : '进行中' }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </dv-border-box-12>
      </div>
    </div>
    <div class="mask" v-show="isLoading"></div>
  </div>
</template>

<script>
import { getServiceData } from '@/api/monitor'
import vueSeamlessScroll from 'vue-seamless-scroll'

const itemColors = ['#96fff6', '#e690d1', '#32c5e9']
let timer = null

export default {
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      totalList: {
        MaintenanceStatus: {
          remaining0: 0,
          remaining5: 0,
          remaining15: 0,
          remaining30: 0
        },
        status: {
          running: 0,
          shutdown: 0
        }
      },
      dataTypeList: {
        dispatchToday: {
          name: 'dispatchD',
          value: 0
        },
        serviceToday: {
          name: 'serviceD',
          value: 0
        },
        dispatchMonth: {
          name: 'dispatchM',
          value: 0
        },
        serviceMonth: {
          name: 'serviceM',
          value: 0
        }
      },
      config: {
        data: [
          {
            name: '',
            value: 0
          }
        ],
        rowNum: 10
      },
      fontSizeOfProgressOption: 18,
      visible: false,
      lowLoad: {
        count: 0
      },
      currentInfo: {
        dataType: 0,
        itemColor: itemColors[0],
        zoom: 5,
        level: 0,
        areaCode: '0',
        lastZoom: 5
      },
      list: [],
      isBoardShow: true,
      isLoading: true,
      formatterWidth: 50,
      isRouteFullscreen: false
    }
  },
  watch: {
    isBoardShow(v) {
      if (!v) {
        this.$nextTick(() => {
          this.isBoardShow = true
        })
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  async mounted () {
    const el = this.$refs.container
    const ratio = 1920 / 1080
    let isFullScreen = document.fullscreenElement !== null
    if (window.innerWidth < 1500) {
      this.fontSizeOfProgressOption = 15
    }
    this.isRouteFullscreen = this.$route.path.startsWith("/fullscreen")
    this.w = window.innerWidth - 245 < 1200 ? 1200 : window.innerWidth - 245
    this.h = Math.ceil(this.w / ratio)
    isFullScreen = this.isRouteFullscreen || isFullScreen
    el.style.width = (isFullScreen ? screen.width : this.w) + 'px'
    el.style.height = (isFullScreen ? Math.ceil(screen.width / ratio) : this.h) + 'px'
    this.flexible()
    try {
      await this.loadScript("https://webapi.amap.com/maps?v=2.0&key=72d96f391e31901608daed111c3535e4")
      await this.loadScript("//webapi.amap.com/ui/1.1/main.js")
      this.scriptLoadedSuccess = true
    } catch(e) {
      console.log(e)
      this.scriptLoadedSuccess = false
    }
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    this.render()
    this.timer = setInterval(this.render, 600000)
  },
  beforeDestroy () {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    clearInterval(this.timer)
    this.mapChart && this.mapChart.dispose()
    this.pieChart && this.pieChart.dispose()
    this.barChart && this.barChart.dispose()
    this.lineChart && this.lineChart.dispose()
  },
  methods: {
    async loadScript(src) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`)
        if (existingScript) {
          resolve()
          return
        }
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    flexible () {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    setBodyFontSize (dpr) {
      if (document.body) {
        document.body.style.fontSize = (12 * dpr) + 'px'
      } else {
        document.addEventListener('DOMContentLoaded', () => { this.setBodyFontSize(dpr) })
      }
    },
    setRemUnit (docEl, isFullScreen) {
      let rem
      if (isFullScreen) {
        rem = docEl.clientWidth / 20
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20
      }
      docEl.style.fontSize = rem + 'px'
    },
    handleFullscreenChange () {
      console.log("fullscreenChange")
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      const el = this.$refs.container
      const isFullScreen = document.fullscreenElement !== null
      if (isFullScreen) {
        el.style.width = window.innerWidth + 'px'
        el.style.height = window.innerWidth * 1080 / 1920 + 'px'
        console.log(window.innerHeight, window.innerWidth)
        this.setRemUnit(document.documentElement, true)
        this.formatterWidth = 100
      } else {
        el.style.width = this.w + 'px'
        el.style.height = this.h + 'px'
        this.setRemUnit(document.documentElement)
        this.formatterWidth = 50
      }
      this.mapChart && this.mapChart.resize()
      this.barChart && this.barChart.resize()
      this.lineChart && this.lineChart.resize()
      this.pieChart && this.pieChart.resize()
      this.isBoardShow = false
    },
    async getData() {
      this.isLoading = true
      try {
        const { data } = await getServiceData()
        this.totalList = data
        for (let i in data.statistic) {
          this.dataTypeList[i].value = data.statistic[i]
        }
        this.totalList.maintenanceTotal = (this.totalList.MaintenanceStatus.remaining0 || 0) + (this.totalList.MaintenanceStatus.remaining5 || 0) + (this.totalList.MaintenanceStatus.remaining15 || 0) + (this.totalList.MaintenanceStatus.remaining30 || 0)
      } catch {
      } finally {
        this.isLoading = false
      }
    },
    setData() {
      if(this.totalList.currentMonthServiceTop10) {
        const list = []
        this.totalList.currentMonthServiceTop10.forEach(item => {
          list.push({
            name: item.key,
            value: item.value
          })
        })
        this.config = {...this.config, data: list}
      }
    },
    setMapData() {
      console.log(this.totalList);
      const result = []
      this.totalList.agentLocationList.forEach(({ lng, lat, company, area, city, province }) => {
        result.push([lng, lat, company, "", "", "", `${province}/${city}/${area}`])
      })
      return result
    },
    getMapOption(data) {
      return {
        amap: {
          center: [111.266579, 35.169665],
          zoom: 5,
          resizeEnable: true,
          renderOnMoving: true,
          mapStyle: 'amap://styles/darkblue',
          zooms: [4, 25]
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#fff'
          },
          formatter: function (params) {
            return `${params.data[2]}<br> 地址：${params.data[6]}`
          }
        },
        animation: true,
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'amap',
            symbol: 'image://data:image/png;base64,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',
            data: data,
            symbolSize: 15,
            encode: {
              value: 2
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            zlevel: 1
          }
        ]
      }
    },
    getZoom(level) {
      switch (level) {
        case 0:
          return 5
        case 1:
          return 7
        case 2:
          return 9
        default:
          break
      }
    },
    getCurrentCenter() {
      const option = this.mapChart.getOption()
      const ampOption = option.amap === undefined ? [{ zoom: 5 }] : option.amap
      return ampOption[0].center
    },
    initMapChart() {
      const data = this.setMapData()
      const option = this.getMapOption(data, this.currentInfo.itemColor)
      if(!this.mapChart) {
        this.mapChart = this.$echarts.init(this.$refs.mapChart)
      }
      this.mapChart.setOption(option)
    },
    getAmapZoom() {
      const option = this.mapChart.getOption()
      const ampOption = option.amap ? option.amap : [{ zoom: 5}]
      return ampOption[0].zoom
    },
    async render () {
      await this.getData()
      this.setData()
      if (this.scriptLoadedSuccess) {
        this.initMapChart()
      }
      this.initBarChart()
      this.initLineChart()
      this.initPieChart()
    },
    async changeDataType(areaCode, dataType) {
      this.currentInfo.dataType = dataType
      this.currentInfo.itemColor = itemColors[dataType]
      await this.getData(areaCode, dataType)
      this.currentInfo.level = 0
      this.currentInfo.zoom = 5
      this.currentInfo.areaCode = '0'
      const data = this.setMapData()
      const option = this.getMapOption(data, this.currentInfo.itemColor)
      this.mapChart.setOption(option)
    },
    initPieChart () {
      const data = []
      this.totalList.maintainType.forEach(({ key, value }) => {
        data.push({
          name: key,
          value
        })
      })
      this.optionOfPieChart = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(26, 26, 83, .8)',
          borderWidth: 0,
          textStyle: {
            color: '#d3d6dd',
            fontSize: 21
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 5,
          top: 'center',
          textStyle: {
            color: '#d3d6dd',
            fontSize: 15
          },
          formatter: (name) => {
            if (name.length > 7) {
              name = name.slice(0, 7) + '...'
            }
            return name
          },
          tooltip: {
            show: true
          },
          show: true
        },
        label: {
          formatter: '{d}%',
          color: '#d3d6dd',
          fontSize: 15
        },
        series: [
          {
            type: 'pie',
            radius: [45, 80],
            center: ['35%', '56%'],
            itemStyle: {
              borderRadius: 0
            },
            data: data
          }
        ]
      }
      if (!this.pieChart) {
        this.pieChart = this.$echarts.init(document.querySelector('.piechart'))
      }
      this.pieChart.setOption(this.optionOfPieChart)
    },
    initBarChart() {
      const xAxis = []
      const data = []
      this.totalList.last7DaysServiceBills.forEach(({ key, value }) => {
        xAxis.push(key)
        data.push([key, value])
      })
      this.optionOfBarChart = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.1)',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
              backgroundColor: '#7B7DDC'
            }
          },
          borderWidth: 0,
          textStyle: {
            color: '#d3d6dd'
          }
        },
        textStyle: {
          color: '#d3d6dd'
        },
        xAxis: {
          type: 'category',
          data: xAxis
        },
        yAxis: {
          type: 'value',
          splitLine: { show: false }
        },
        grid: {
          top: '20%',
          left: '8%',
          right: '5%',
          bottom: '10%'
        },
        series: [
          {
            data,
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#956FD4' },
                { offset: 1, color: '#3EACE5' }
              ])
            }
          }
        ]
      }
      if (!this.barChart) {
        this.barChart = this.$echarts.init(document.querySelector('.barchart'))
      }
      this.barChart.setOption(this.optionOfBarChart)
    },
    initLineChart() {
      const seriesList = []
      const map = {}
      let maxofMap = 0, maxItemXAxis = []
      this.totalList.faultTrend.forEach(({ key, value, type }) => {
        if (map[type]) {
          map[type].xAxis.push(key)
          map[type].data.push(value)
          maxofMap = Math.max(maxofMap, map[type].xAxis.length)
          if (maxofMap === map[type].xAxis.length) {
            maxItemXAxis = map[type].xAxis
          }
        } else {
          map[type] = {
            xAxis: [key],
            data: [value]
          }
        }
      })
      const legendData = Object.keys(map)
      legendData.forEach(l => {
        for (let i = map[l].xAxis.length; i < maxofMap; i++) {
          map[l].data.push(0)
          map[l].xAxis.push(maxItemXAxis[i])
        }
        const seriesItem = {
          name: l,
          type: 'line',
          data: map[l].data
        }
        seriesList.push(seriesItem)
      })
      this.optionOfLineChart = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(26, 26, 83, .8)',
          borderWidth: 0,
          textStyle: {
            color: '#d3d6dd'
          },
          confine: true
          // appendToBody: true
        },
        legend: {
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          data: legendData,
          textStyle: {
            color: '#d3d6dd',
            fontSize: 16
          },
          width: '100%',
          show: true,
          tooltip: {
            show: true,
            textStyle: {
              fontSize: 21
            }
          },
          formatter: name => {
            // 使用formatter来自定义文本，并加上省略号
            return this.$echarts.format.truncateText(name, this.formatterWidth, '12px Microsoft YaHei', '…');
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: maxItemXAxis,
          axisLabel: {
            fontSize: 15
          }
        },
        yAxis: {
          type: 'value',
          splitLine: { show: false },
          axisLabel: {
            fontSize: 15
          }
        },
        grid: {
          top: '20%',
          left: '8%',
          right: '5%',
          bottom: '12%'
        },
        textStyle: {
          color: '#d3d6dd'
        },
        series: seriesList
      }
      if (!this.lineChart) {
        this.lineChart = this.$echarts.init(document.querySelector('.linechart'))
      }
      this.lineChart.setOption(this.optionOfLineChart)
    }
  }
}
</script>

<style lang="less" scoped>
.fullscreen {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0;
  }
  &::-webkit-scrollbar-track {
    width: 0;
  }
  &::-webkit-scrollbar-thumb {
    width: 0;
  }
}
#map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000001;
}
.container {
  position: relative;
  // overflow: hidden;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  background-color:rgba(0,0,0,0.5);
  width: 100%;
  height: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-dialog {
  width: 60%;
  // margin: 30rem auto;
  padding: .3125rem;
  border-radius: .5208rem;
  background-color: rgb(19, 25, 47);
  color: #fff;
  //background-color: #222;
  //box-shadow: 0 8px 100px -4px rgb(0 0 0 / 50%);
  box-shadow: 0 8px 20px -4px rgba(0, 0, 0, 0.49);
  .list-dialog-inner {
    width: 100%;
    max-height: 6.25rem;
    padding-right: .625rem;
    padding-left: .5208rem;
    overflow-y: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {  /*滚动条整体样式*/
      width: 4px;           /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
      border-radius: 5px;
      box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: rgba(150, 255, 246, 0.9);
    }
    &::-webkit-scrollbar-track {  /*滚动条轨道*/
      box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 0;
      background: rgba(0,0,0,0.1);
    }
  }
}
.header {
  width: 100%;
  height: 20%;
  position: absolute;
  top: 1%;

  .header-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .title {
      text-align: center;
      font-size: .2917rem;
      color: #fff;
      font-weight: 600;
      margin: .1042rem 0;
      line-height: .2083rem;
    }
  }
}

.toggleNav {
  position: absolute;
  top: 12%;
  left: 50%;
  width: 40%;
  height: 10%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: .22rem;
    color: #fff;
    width: 23%;
    height: 100%;
    border-radius: 15%;
    text-align: center;
    background-color: rgba(19, 25, 47, 0.75);
    padding: 1% 1%;
  }
}

.col {
  width: 26%;
  height: 93%;
  position: absolute;
  top: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .dv-border-box-12 {
    padding: 2.6%;
    position: relative;

    svg {
      width: 0.3125rem;
      height: 0.3125rem;
      margin: 1%;
      color: #5cd9e8;
    }

    .title {
      position: absolute;
      color: #fff;
      left: .4167rem;
      white-space: nowrap;
      top: .1563rem;
      transform: translateY(-50%);
      font-size: .1667rem;
    }
  }
}

.flex {
  width: 100%;
  display: flex;
  justify-content: center;

  .analysis {
    text-align: center;
    font-size: .2083rem;
    margin: 0;
    font-weight: 600;
    color: #fff;
  }
}

.chart-inner-bg {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.flex_column {
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    text-align: center;
  }
}

[class^="icon"] {
  width: 0.729rem;
  height: 0.729rem;
  margin: 0.208rem auto 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  &.icon-kwc {
    background-image: url(../../../assets/kwc.png);
  }
  &.icon-kwh {
    background-image: url(../../../assets/kwh.png);
  }
  &.icon-avg-load {
    background-image: url(../../../assets/avgLoad.png);
  }
  &.icon-avg-temp {
    background-image: url(../../../assets/avgTemp.png);
  }
  &.icon-warning {
    background-image: url(../../../assets/warning.png);
  }
  &.icon-date {
    background-image: url(../../../assets/date.png);
  }
}

h2.data {
  color: #fff;
  font-size: 0.1875rem;
}

h3.description {
  color: #fff;
  font-size: 0.146rem;
}

.maintenance {
  width: 100%;
  height: 100%;
  padding: 10% 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  * {
    color: #fff;
    font-size: 0.208rem;
  }
  & > div {
    display: flex;
    justify-content: space-around;
  }
  .maintenance-status {
    width: 100%;
    height: 10px;
    border-radius: 5px;
    background: linear-gradient(90deg,#e7453f,#fff35c);
  }
}
@media screen and (max-width: 1500px) {
  .w {
    overflow-x: auto;
  }
  .dv-decoration-10 {
    width: 28% !important;
  }
  .title_wrapper {
    width: 20% !important;
  }
  :-webkit-full-screen {
    .w {
      overflow-x: hidden;
    }
    .dv-decoration-10 {
      width: 30% !important;
    }
    .title_wrapper {
      width: 16% !important;
    }
  }
}
@media screen and (max-width: 1024px) {
  :-webkit-full-screen {
    .col {
      .capsule_wrapper {
        padding-right: 0 !important;
        height: unset !important;
        transform: scaleY(.96) !important;
        .dv-capsule-chart {
          width: 90% !important;
          height: unset !important;
        }
      }
    }
  }
}
@media screen and (max-width: 900px) {
  :-webkit-full-screen {
    .col {
      width: 30%;
      br {
        display: none;
      }
      .capsule_wrapper {
        padding-right: 0 !important;
        height: unset !important;
        transform: scaleY(.76) !important;
        .dv-capsule-chart {
          width: 90% !important;
          height: unset !important;
        }
      }
    }
  }
}
.warp {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    li {
      display: flex;
      flex-direction: row;
      padding: 8px 5px;
      a {
        display: block;
        line-height: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
      }
    }
  }
}
.dot-wrap {
  padding: 10px;
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}
.success-color {
  color: #35e4b1;
}
.primary-color {
  color: #2da4eb;
}
.success-bgc {
  background-color: #35e4b1;
}
.primary-bgc {
  background-color: #2da4eb;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: wait;
  // z-index: 1000;
  opacity: 0;
}
.svgs {
    cursor: pointer;
    path {
      fill: transparent;
    }
    &:hover {
      path {
        fill: #fff;
      }
    }
  }
</style>
